import React, { Fragment } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, func, oneOf, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { ContextMenu } from '../context-menu/context-menu.js';
import { Link } from '../link/link.js';
import { Option } from '../option/option.js';
import { DynamicActionsAPI } from './dynamic-actions-api.js';
import { DynamicActionType } from './dynamic-actions-constants.js';
import './dynamic-actions.css';
function getContextMenuActions(actions) {
    const options = [];
    for (const action of actions) {
        options.push(React.createElement(Option, { key: action.title, onClick: action.action, value: action.title }));
    }
    return (React.createElement(ContextMenu, { uuid: "dynamic-actions-context-menu" }, options));
}
function getLinkActions(actions) {
    return (React.createElement(Fragment, null, actions.map(action => (React.createElement(Link, { key: action.title, onClick: action.action, value: action.title })))));
}
function DynamicActions(props) {
    const content = {
        [DynamicActionType.CONTEXT_MENU]: () => getContextMenuActions(props.actions),
        [DynamicActionType.LINK]: () => getLinkActions(props.actions),
    }[props.type];
    return (React.createElement("div", { className: "c-dynamic-actions" }, content()));
}
DynamicActions.propTypes = {
    actions: arrayOf(shape({ action: func, title: string })),
    type: oneOf(enumValues(DynamicActionType)),
};
DynamicActions.defaultProps = {
    actions: [],
    type: DynamicActionType.CONTEXT_MENU,
};
const awesomeProps = {
    api: DynamicActionsAPI,
    type: ComponentType.NAVIGATION,
};
AwesomeComponent(awesomeProps)(DynamicActions);
export { DynamicActions, };
//# sourceMappingURL=dynamic-actions.js.map